//首页背景图
export const homePageImg = "images/tempImgs/homePage.png"
//菜单栏
export const menuCardList = [
    {
        title: "平台介绍",
        introduce: "作为一个不了解遥感知识的新手，如何了解遥感基础知识，并且合理地使用本网站资源。",
        buttonText: "平台介绍",
        address: "images/tempImgs/top1.png",
        location: "/NetIntroduce",
    },
    {
        title: "资源查询",
        introduce: "实现基础地理数据、产品、模型、算法和工具等的检索、浏览与共享下载功能。",
        buttonText: "资源查询",
        address: "images/tempImgs/top2.png",
        location: "/ResourcesSearch",
    },
    {
        title: "技术服务",
        introduce: "针对十三五卫星处理需求，开展真值数据采集与处理、共性技术研发与测评、共性产品处理与检验等服务。",
        buttonText: "技术服务",
        address: "images/tempImgs/top3.png",
        location: "/TechnicalService",
    },
]
//资源收集
export const resourcesCollectCardList = [
    {
        title: "空基卫星",
        // introduce: "应用于应急管理、生态环境、住房与城乡建设、交通运输、农业农村、林业草原等相关领域的24颗卫星进一步拓展我国自然资源调查监测技术手段，大幅度提高山水林田湖草等自然资源定量化调查监测能力。",
        introduce: "提供空基十二五卫星、空基十三五卫星、高分系列卫星、其他卫星数据科普。",
        address: "images/tempImgs/1.png",
        icon: "images/tempImgs/icon1.png",
        label: "卫星数据",
        location: "/Introduce",
        index: 1,
    },
    {
        title: "光学微波站网",
        introduce: "由分布在我国的28个省份或自治区的48个站点组成，共布设有326台套专业遥感设备，可定期获取地面测量参数，为空基陆地卫星6类24种遥感共性产品的光学和微波载荷的算法研究和产品验证提供数据支持。",
        address: "images/tempImgs/2.png",
        icon: "images/tempImgs/icon2.png",
        label: "光学微波",
        location: "/GXWB",
    },
    {
        title: "电磁站网",
        introduce: "由5个电磁真实性检验站和1个电离层观测平台组成，布设设备20余台套，可定期获取地面电磁观测数据，以供电磁卫星发射后开展其观测数据的真实性检验、地面电磁、电离层测高、GPS/北斗的对比观测的应急观测。",
        address: "images/tempImgs/3.png",
        icon: "images/tempImgs/icon3.png",
        label: "电磁数据",
        location: "/DC",
    },
    {
        title: "基准与综合实验室",
        introduce: "室内定标实验室、场景模拟实验室（半物理仿真）、计算机仿真系统组成。",
        address: "images/tempImgs/4.png",
        icon: "images/tempImgs/icon4.png",
        label: "仿真数据",
        location: "/JZYZHSY",
    },
    {
        title: "综合实验场",
        introduce: "由六大综合实验场组成，其试验属于短期机动性试验，主要用于真实性检验和遥感产品反演算法的理论研究、卫星在轨测试和产品验证，可作为光学微波卫星真实性检验站网的有效补充。",
        address: "images/tempImgs/5.png",
        icon: "images/tempImgs/icon5.png",
        label: "实验数据",
        location: "/ZHSY",
    },
]
//资源收集统计展示
export const resourcesCollectLastCardList = [
    {
        num: "54",
        type: "类",
        name: "产品",
    },
    {
        num: "1",
        type: "类",
        name: "工具",
    },
    {
        num: "957.57",
        type: "TB",
        name: "数据",
    },
    {
        num: "921.50",
        type: "TB",
        name: "服务卫星数据",
    },
]
//培训知识
export const cultivateKnowledgeCardList = [
    {
        title: "应用案例",
        icon: "images/tempImgs/icon6.png",
        location: "/OnlineTraining"
    },
    {
        title: "在线课堂",
        icon: "images/tempImgs/icon7.png",
        location: "/LiveManager"
    },
    {
        title: "知识库",
        icon: "images/tempImgs/icon8.png",
        location: "/GuideSearch"
    },
    {
        title: "标准规范共享",
        icon: "images/tempImgs/icon9.png",
        location: "/BZGF"
    },
    {
        title: "文档资料共享",
        icon: "images/tempImgs/icon10.png",
        location: "/Download"
    },
    {
        title: "在线论坛",
        icon: "images/tempImgs/icon11.png",
        location: "/Q&ACenter"
    },
]
//资源分享
export const resourcesShareCardList = [
    {
        title: "遥感地理数据检索",
        address: "images/tempImgs/资源共享/1.png",
        hoverAddress: "images/tempImgs/资源共享/1.1.png",
        menuList: [
            { menuTitle: "→卫星数据", location: "" },
            { menuTitle: "→共性产品", location: "" },
            { menuTitle: "→遥感特征数据影像", location: "" },
            { menuTitle: "→基础地理数据影像", location: "" },
        ],
        location: "/geovis"
    },
    {
        title: "真值数据",
        introduce: "辐射类、几何类、陆表类、植被类、大气类、水体类地面实测数据。",
        address: "images/tempImgs/资源共享/2.png",
        location: "/ZZSJ"
    },
    {
        title: "算法模型",
        introduce: "提供在线共性技术算法模型测评服务及标准技术工具在线流程定制与处理服务，支撑共性技术算法模型创新、促进技术迭代升级与共享。",
        address: "images/tempImgs/资源共享/3.png",
        location: "/AlgorithmModelSharing"
    },
    {
        title: "处理工具",
        introduce: "提供遥感数据处理工具的条件精确搜索。",
        address: "images/tempImgs/资源共享/4.png",
        location: "/AlgorithmToolsSharing"
    },
]
//技术服务
export const technologyServiceCardList = [
    {
        title: "站网数据处理",
        introduce: "站网数据处理是指对通过地面站点采集到的数据进行分析、清理和整理的过程，以提取有用信息并为后续应用做准备。",
        address: "images/tempImgs/技术服务/1.png",
        location: "/DMSJ"
    },
    {
        title: "场网数据处理",
        introduce: "场网数据处理是指对通过实验场采集到的数据进行分析、清理和整理的过程，以提取有用信息并为后续应用做准备。",
        address: "images/tempImgs/技术服务/1.png",
        location: "/DMSJ"
    },
    {
        title: "共性产品检验",
        introduce: "依托现有观测站网建设，在全国范围内选择一定数量典型区域的观测场、站，天地一体化同步观测采集相关数据，实现产品与算法的质量与稳定度检验，支撑基于自主遥感数据的算法研发并对卫星应用效能进行评价。",
        address: "images/tempImgs/技术服务/1.png",
        location: "/GXWBCPJY"
    },
    {
        // title: "算法工具处理",
        title: "算法工具测评",
        introduce: "立足已有国产卫星数据处理共性技术基础，着眼为未来共性技术发展和应用目标，为用户提供面向遥感应用全过程的稳定、可信、可追溯的数据处理共性技术工具集、技术检验评价工具集和在线技术检验评价实验测试环境。",
        address: "images/tempImgs/技术服务/1.png",
        location: "/GXJS"
    },
    {
        title: "处理流程定制",
        introduce: "用户可以根据自身需求对自己发布的流程进行增删改查，或者再编辑。也可以查看自己已经发布的流程，对自己发布的流程进行管理。 ",
        address: "images/tempImgs/技术服务/1.png",
        location: "/processdesign"
    },
    {
        title: "产品生产定制",
        introduce: "将平台作为服务，提供业务应用的开发环境和运行环境，调用强大的计算能力进行数据处理和信息产品生产 ",
        address: "images/tempImgs/技术服务/1.png",
        location: "/geovis"
    },
]
//合作单位
export const unitsList = [
    {
        title: "中国科学院",
        icon: "images/tempImgs/底部说明/image1.png",
        location: "https://www.cas.cn/"
    },
    {
        // title: "中国地震局地壳压力研究所",
        title: "中国地震局地质研究所",
        icon: "images/tempImgs/底部说明/image2.png",
        location: "https://www.eq-igl.ac.cn/"
    },
    {
        title: "中国科学院空天信息创新研究院",
        icon: "images/tempImgs/底部说明/image3.png",
        location: "http://www.aircas.ac.cn/"
    },
    // {
    //     title: "国家测绘地理信息局卫星测绘应用中心",
    //     icon: "images/tempImgs/底部说明/image4.png",
    //     location: "http://www.sasmac.cn/"
    // },
]


/* 顶部走马灯 */
//公告
// export const noticeDatas = {
//     title: "关于做好网络和账户安全的通知",
//     time: "2022-12-22",
//     content: `尊敬的各位用户：
//     为进一步加强本平台的网络服务安全和用户信息安全，提升陆地观测卫星数据服务平台运行服务效率，请广大注册单位及用户针对注册账户信息进行安全自查，对在本平台注册提交的单位及个人资料、用户名、密码等信息进行核实，及时修改相关信息，对弱密码及时进行修改；对日常使用本平台的软硬设备及网络环境进行全面安全检查，确保单位或个人网络及账户安全。
//     对于本平台使用过程中遇到的任何问题，请第一时间拨打010-58937060或发送邮件至service@cresda.com进行反馈。
//     感谢您的理解与配合！`,
// }
export const noticeDatas = {
    title: "陆地观测卫星共性应用支撑平台",
    // time: "2022-12-22",
    content: `
         针对国家民用空间基础设施立项的陆地观测业务星和科研星共性应用支撑保障需求，按照统筹规划、分步建设、协同运行、资源共享原则，建立陆地观测卫星共性应用支撑平台，实现业务卫星和科研卫星各载荷信息产品算法检验及质量评价、资源共享，为卫星遥感应用业务部门与区域应用提供服务，发挥国家投资最大经济效益，支撑、支持、推进、推广与服务我国民用航天技术发展，并为后续进一步统筹建设和具体实施提供技术支撑。
         平台面向空基12型24颗陆地观测卫星，建成国家级多谱段、多手段、场站结合、室内外一体化的真实性检验场网系统，搭建集群、互联网、一站式共性技术支撑服务系统，提供面向遥感应用全过程的稳定、可信、可追溯的处理、检验、评价服务，形成多卫星各载荷信息产品算法检验及质量评价、资源共享的多模式综合服务体系，服务行业、区域、科教、大众四类用户。`,
}
//新闻
export const newsDatas = {
    image: "images/tempImgs/走马灯/新闻图片1.png",
    title: "陆地生态碳监测卫星在轨激光定标试验取得圆满成功",
    time: "2022-12-22",
    content: `2022年11月22日，中国资源卫星应用中心遥感卫星外场定标试验队依托内蒙古激光定标试验场，在中国航天科技集团有限公司五院遥感卫星总体部、锡林郭勒盟阿巴嘎旗自然资源局、中国科学院空天信息创新研究院、湖北工业大学、武汉大学、北京中勘迈普科技有限公司等单位支持与配合下，完成了为期两个月的“句芒号”陆地生态碳监测卫星激光外场定标试验。“句芒号”卫星在轨激光定标试验取得圆满成…`
}
//统计
export const statisticsDatas = [
    {
        num: "25",
        type: "颗",
        name: "卫星",
        icon: "images/tempImgs/走马灯/统计/1.png"
    },
    {
        num: "122",
        type: "类",
        name: "产品",
        icon: "images/tempImgs/走马灯/统计/2.png"
    },
    {
        num: "95",
        type: "个",
        name: "工具",
        icon: "images/tempImgs/走马灯/统计/3.png"
    },
    {
        num: "56924",
        type: "TB",
        name: "数据",
        icon: "images/tempImgs/走马灯/统计/4.png"
    },
    {
        num: "3614.46",
        type: "TB",
        name: "服务卫星数据",
        icon: "images/tempImgs/走马灯/统计/5.png"
    },
]
//介绍
export const introduceDatas = {
    image: "images/tempImgs/走马灯/新闻图片2.png",
    precedent: "应用案例",
    title: "林业应用场景",
    content: "2022年11月22日，中国资源卫星应用中心遥感卫星外场定标试验队依托内蒙古激光定标试验场，在中国航天科技集团有限公司五院遥感卫星总体部、锡林郭勒盟阿巴嘎旗自然资源局、中国科学院空天信息创新研究院、湖北工业大学、武汉大学、北京中勘迈普科技有限公司等单位支持与配合下，完成了为期两个月的“句芒号”陆地生态碳监测卫星激光外场定标试验。“句芒号”卫星在轨激光定标试验取得圆满成…2022年11月22日，中国资源卫星应用中心遥感卫星外场定标试验队依托内蒙古激光定标试验场，在中国航天科技集团有限公司五院遥感卫星总体部、锡林郭勒盟阿巴嘎旗自然资源局、中国科学院空天信息创新研究院、湖北工业大学、武汉大学、北京中勘迈普科技有限公司等单位支持与配合下，完成了为期两个月的“句芒号”陆地生态碳监测卫星激光外场定标试验。“句芒号”卫星在轨激光定标试验取得圆满成…"
}

/* ------------------ */